// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__28TVw","loaderOuter":"PageOverlayLoader_loaderOuter__2GwrJ"};